import { AlertCircle, Loader2 } from 'lucide-react'

export function Spinner({ label = 'Loading…' }: { label?: string }) {
	return (
		<div className="flex items-center justify-center gap-2 p-10 text-sm text-ink-soft">
			<Loader2 className="h-4 w-4 animate-spin" />
			{label}
		</div>
	)
}

// Errors are shown, never swallowed: the backend already phrases them for a
// human ({ error: string }), and an operator needs to know whether they are
// looking at no data or at a failed request.
export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
	const message = error instanceof Error ? error.message : 'Something went wrong'
	return (
		<div className="flex flex-col items-center gap-3 p-10 text-center">
			<AlertCircle className="h-5 w-5 text-red-600" />
			<p className="text-sm text-ink">{message}</p>
			{onRetry && (
				<button type="button" className="btn-secondary" onClick={onRetry}>
					Try again
				</button>
			)}
		</div>
	)
}

export function EmptyState({ message }: { message: string }) {
	return <div className="p-10 text-center text-sm text-ink-faint">{message}</div>
}
